import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../Fetching"; // <-- ide importáljuk

const LoginPage = () => {
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("TOKEN:", localStorage.getItem("token"));
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setError("");

  try {
    const data = await login(form.username, form.password);
    localStorage.setItem("token", data.token);
    navigate("/admin");
  } catch (err) {
    setError("Hibás felhasználónév vagy jelszó");
  } finally {
    setIsLoading(false);
  }
};

  return (
    <div className="login-container">
      <div className="login-form-wrapper">
        <h1>AI Inside Life</h1>
        <p>Kérjük, jelentkezzen be a folytatáshoz</p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <input
              name="username"
              placeholder="Felhasználónév"
              value={form.username}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-group">
            <input
              name="password"
              type="password"
              placeholder="Jelszó"
              value={form.password}
              onChange={handleChange}
              required
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button 
            type="submit" 
            disabled={isLoading}
            className={isLoading ? "loading" : ""}
          >
            {isLoading ? "Bejelentkezés..." : "Bejelentkezés"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
